import React, { FC, RefObject } from 'react'
import {
	classes,
	isGR6_4SectionA,
	isGR6_4SectionB,
	isGR6_4SectionC
} from './__index.utils'
import { CheckboxList, RadioList } from '@utils/request'
import * as utilsList from './__index.utils'
import CheckboxInput from '../inputs/checkbox.input'
import MeasurementInput from '../inputs/measurement.input'
import { REQUEST_CONFIGS_KEYS } from '@services/constants'
import Notification from '@components/ui/notification'
import TextInput from '../inputs/text.inputs'
import Text from '@components/ui/text'
import { joinClasses } from '@utils/styles'

const Step4_4LandDevelopmentWork = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	updateCheckBoxInput
}) => {
	const {
		typesOfWorkBoat,
		typesOfStructureBoat,
		typesOfStructureBoatOther,
		areaPier,
		areaUnitPier,
		widthBoatShelter,
		widthUnitBoatShelter,
		depthBoatShelter,
		depthUnitBoatShelter,
		heightBoatShelter,
		heightUnitBoatShelter,
		areaBoatShelter,
		areaUnitBoatShelter,
		boatShelterMaterial,
		areaLandingStage,
		areaUnitLandingStage,
		boatPierDeclaration
	} = formInputs

	const radioListTypesOfWorkBoat: CheckboxList[] =
		utilsList.radioListTypesOfWorkBoat(pageAssets)

	const radioListTypesOfPier: CheckboxList[] =
		utilsList.radioListTypesOfPier(pageAssets)

	const radioListMeasurementUnit: RadioList[] =
		utilsList.radioListMeasurementUnit(pageAssets)

	const radioListMeasurement2Unit: RadioList[] =
		utilsList.radioListMeasurement2Unit(pageAssets)

	const pierAreaThrowWarning = () => {
		return (
			(areaUnitPier.value ===
				REQUEST_CONFIGS_KEYS.measurement_unit.meters_unit &&
				Number(areaPier.value) > 20) ||
			Number(areaPier.value) > 215.27
		)
	}

	return (
		<>
			{/* typesOfWorkDiverseInput */}

			<CheckboxInput
				name={typesOfWorkBoat.name}
				label={typesOfWorkBoat.label}
				description={typesOfWorkBoat.description}
				value={`${typesOfWorkBoat.value}`}
				list={radioListTypesOfWorkBoat}
				onChange={(value) => updateCheckBoxInput(typesOfWorkBoat, value)}
				required={typesOfWorkBoat.required}
				hasError={errors.includes(typesOfWorkBoat.name)}
				ref={typesOfWorkBoat.ref as RefObject<HTMLInputElement>}
				errors={errors}
				shouldNotDivide
				hasBackgroundWrapper
				onFixError={onFixError}
				newCheckValue
				isSummaryStep={isSummaryStep}
			/>

			{typesOfWorkBoat.value.includes(
				REQUEST_CONFIGS_KEYS.isBoatDevelopment.pierOrShelter
			) && (
				<>
					<h6 className={classes.h6}>
						{
							pageAssets?.request_form_landDevelopmentWorkPermit_isBoatDevelopment_landingStage
						}
					</h6>
					<CheckboxInput
						name={typesOfStructureBoat.name}
						label={typesOfStructureBoat.label}
						description={typesOfStructureBoat.description}
						value={`${typesOfStructureBoat.value}`}
						list={radioListTypesOfPier}
						onChange={(value) =>
							updateCheckBoxInput(typesOfStructureBoat, value)
						}
						required={typesOfStructureBoat.required}
						hasError={errors.includes(typesOfStructureBoat.name)}
						ref={typesOfStructureBoat.ref as RefObject<HTMLInputElement>}
						errors={errors}
						shouldNotDivide
						hasBackgroundWrapper
						onFixError={onFixError}
						newCheckValue
						isSummaryStep={isSummaryStep}
					/>

					{isGR6_4SectionA(typesOfStructureBoat.value) && (
						<TextInput
							id={typesOfStructureBoatOther.name}
							label={typesOfStructureBoatOther.label}
							value={typesOfStructureBoatOther.value}
							onChange={(value) =>
								updateInput(typesOfStructureBoatOther.name, value)
							}
							hasError={errors.includes(typesOfStructureBoatOther.name)}
							required={typesOfStructureBoatOther.required}
							ref={typesOfStructureBoatOther.ref as RefObject<HTMLInputElement>}
							maxCharacters={100}
							isSummaryStep={isSummaryStep}
						/>
					)}

					{isGR6_4SectionB(typesOfStructureBoat.value) && (
						<>
							<h6 className={classes.h6}>
								{
									pageAssets?.request_form_landDevelopmentWorkPermit_boatPier_dimensions
								}
							</h6>

							<MeasurementInput
								measurementInput={areaPier}
								unitInput={areaUnitPier}
								listMeasurementUnit={radioListMeasurement2Unit}
								maxCharacters={6}
								isSummaryStep={isSummaryStep}
								errors={errors}
								onFixError={onFixError}
								updateInput={updateInput}
								hasError={errors?.includes(areaPier.name)}
								reducedMargin
							/>

							{pierAreaThrowWarning() && (
								<Notification
									type="warning"
									text={
										pageAssets?.request_form_landDevelopmentWorkPermit_boatPier_warning
									}
								/>
							)}
						</>
					)}

					{isGR6_4SectionC(typesOfStructureBoat.value) && (
						<>
							{(!isSummaryStep ||
								(isSummaryStep &&
									(widthBoatShelter.value ||
										depthBoatShelter.value ||
										heightBoatShelter.value ||
										areaBoatShelter.value))) && (
								<h6 className={classes.h6}>
									{
										pageAssets?.request_form_landDevelopmentWorkPermit_boatShelter_dimensions
									}
								</h6>
							)}

							<div className={pageUtils.classes.fieldsContainer}>
								<MeasurementInput
									measurementInput={widthBoatShelter}
									unitInput={widthUnitBoatShelter}
									listMeasurementUnit={radioListMeasurementUnit}
									maxCharacters={6}
									isSummaryStep={isSummaryStep}
									errors={errors}
									onFixError={onFixError}
									updateInput={updateInput}
									hasError={errors?.includes(widthBoatShelter.name)}
									reducedMargin
								/>

								{/* depthBoatShelterInput */}
								<MeasurementInput
									measurementInput={depthBoatShelter}
									unitInput={depthUnitBoatShelter}
									listMeasurementUnit={radioListMeasurementUnit}
									maxCharacters={6}
									isSummaryStep={isSummaryStep}
									errors={errors}
									onFixError={onFixError}
									updateInput={updateInput}
									hasError={errors?.includes(depthBoatShelter.name)}
									reducedMargin
								/>

								{/* heightBoatShelterInput*/}
								<MeasurementInput
									measurementInput={heightBoatShelter}
									unitInput={heightUnitBoatShelter}
									listMeasurementUnit={radioListMeasurementUnit}
									maxCharacters={6}
									isSummaryStep={isSummaryStep}
									errors={errors}
									onFixError={onFixError}
									updateInput={updateInput}
									hasError={errors?.includes(heightBoatShelter.name)}
									reducedMargin
								/>

								{/* areaBoatShelterInput */}
								<MeasurementInput
									measurementInput={areaBoatShelter}
									unitInput={areaUnitBoatShelter}
									listMeasurementUnit={radioListMeasurement2Unit}
									maxCharacters={12}
									isSummaryStep={isSummaryStep}
									errors={errors}
									onFixError={onFixError}
									updateInput={updateInput}
									hasError={errors?.includes(areaBoatShelter.name)}
									reducedMargin
								/>
							</div>

							<TextInput
								id={boatShelterMaterial.name}
								label={boatShelterMaterial.label}
								value={boatShelterMaterial.value}
								onChange={(value) =>
									updateInput(boatShelterMaterial.name, value)
								}
								hasError={errors.includes(boatShelterMaterial.name)}
								required={boatShelterMaterial.required}
								ref={boatShelterMaterial.ref as RefObject<HTMLInputElement>}
								maxCharacters={100}
								isSummaryStep={isSummaryStep}
							/>
						</>
					)}

					<>
						{!isSummaryStep ? (
							<>
								<h6 className={classes.h6}>
									{pageAssets?.request_form_statement_title}
								</h6>
								<div className={classes.checkbox2Container}>
									<span
										className={classes.checkboxWrapper}
										style={{ marginTop: '30px' }}
									>
										<input
											onChange={(e: any) =>
												updateInput(boatPierDeclaration.name, e.target.checked)
											}
											value={boatPierDeclaration.value?.toString()}
											className={classes.checkbox2}
											checked={boatPierDeclaration.value.toString() == 'true'}
											type="checkbox"
											name={boatPierDeclaration.name}
											id={boatPierDeclaration.labelKey}
										/>

										<label
											className={joinClasses([
												classes.checkbox2Label,
												errors?.includes(boatPierDeclaration.name)
													? classes.errorCheck
													: ''
											])}
											htmlFor={boatPierDeclaration.labelKey}
										>
											{boatPierDeclaration.label}{' '}
											<a className={classes.errorCheck}>*</a>
										</label>
									</span>
								</div>
							</>
						) : (
							<div style={{ marginBottom: '10px' }}>
								{boatPierDeclaration.label}
							</div>
						)}
					</>
				</>
			)}

			{typesOfWorkBoat.value.includes(
				REQUEST_CONFIGS_KEYS.isBoatDevelopment.landingStage
			) && (
				<>
					<h6 className={classes.h6}>
						{
							pageAssets?.request_form_landDevelopmentWorkPermit_isBoatDevelopment_landingStage
						}
					</h6>
					<MeasurementInput
						measurementInput={areaLandingStage}
						unitInput={areaUnitLandingStage}
						listMeasurementUnit={radioListMeasurement2Unit}
						maxCharacters={12}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(areaLandingStage.name)}
						reducedMargin
					/>
				</>
			)}
		</>
	)
}

export default Step4_4LandDevelopmentWork
